import { Injectable }    from '@angular/core';
import { environment } from 'src/environments/environment';
import {SearchModel, SearchResultModel, SupplierOfferItemModel} from 'src/common';
import {HttpClient} from '@angular/common/http';
import {SupplierAuctionRangListModel} from "./supplier-auction-rang-list.model";



const localApiUrl = `${environment.apiUrl}/SupplierAuctionRangList`;

@Injectable()
export class SupplierAuctionRangListService {

  constructor(private http: HttpClient) { }

  search(search: SearchModel): Promise<SearchResultModel<SupplierAuctionRangListModel>> {
      return this.http.post<SearchResultModel<SupplierAuctionRangListModel>>(`${localApiUrl}/Search`, search).toPromise();
  }

  getAll(): Promise<SupplierAuctionRangListModel[]> {
	return this.http.get<SupplierAuctionRangListModel[]>(`${localApiUrl}/All`).toPromise();
  }

  getById(id: number): Promise<SupplierAuctionRangListModel> {
    return this.http.get<SupplierAuctionRangListModel>(`${localApiUrl}/Details/${id}`).toPromise();
  }

  delete(id: number): Promise<void> {
	return this.http.get<void>(`${localApiUrl}/Delete/${id}`).toPromise();
  }

  save(model: any): Promise<void> {
    return this.http.post<void>(`${localApiUrl}/Save`, model).toPromise();
  }


  // custom-start

  getAuctionRangList(auctionId): Promise<SupplierOfferItemModel[]> {
    return this.http.get<SupplierOfferItemModel[]>(`${environment.apiUrl}/SupplierAuctionOffer/RangList?requestRoundId=` + auctionId).toPromise();
  }

  // custom-end

}



